<template>
  <div id="introducao">
    <div class="conteudo-dicas" :class="{'hidden':isError}">
      <div class=" d-flex justify-content-center align-items-center" >
        <input type="file" ref="fileInput" id="file"  class="hidden" name="file"  @change="handleFileChange" />
        <button name="botao" ref="botao" class="btn btn-lg btn-primary" @click="openFileInput">Selecione um arquivo</button>
      </div>
      <div id="footer"></div>
    </div>

    <div class="page-error" :class="{'hidden':!isError}">
      <Error
          :title="errorMensage.title"
          :subtitle="errorMensage.subtitle"
          :button-text="errorMensage.button"
          :callback="errorMensage.callback"
      ></Error>
    </div>

  </div>
</template>
<script>
import Error from "../shared/Error";
import UploadCNHDigitalService from "../../services/UploadCNHDigitalService";
import DispatchTags from "../../utils/DispatchTags";

export default {
  name: "DocCnhDigital",
  components: { Error },
  mounted() {
    this.uploadCnhService = new UploadCNHDigitalService();
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", false);
    this.openMOdal();
  },
  data: function () {
    return {
      isError:false,
      showAllow: false,
      selectedFile: false,
      uploadCnhService: '',
      errorMensage : {
        title : 'Algo deu errado ao acessar seus documentos',
        subtitle : 'Precisamos do acesso aos seus documentos e pastas para abrir a CNH digital',
        button : 'Permitir acesso',
        callback : this.acaoBtnTentarNovamente
      }
    };
  },
  computed: {},
  methods: {
    openMOdal:function (){
      DispatchTags.dispatchNoninteraction('ModalPermitirAcessoDocumentosCnhDigital');
      if(confirm("Permitir o App Vivo acessar seus documentos e pastas?")){
        this.openFileInput();
      }else{
        DispatchTags.dispatchScreenView('ErroAcessoCnhDigital');
        DispatchTags.dispatchNoninteraction('ErroAcessoCnhDigital');
        this.isError = true;
      }
    },
    acaoBtnTentarNovamente:function (){
      DispatchTags.dispatchInraction('PermitirAcessoDocumentosCnhDigital');
      this.openMOdal();
    },
    openFileInput() {
      try {
        DispatchTags.dispatchScreenView('CnhDigital');
        $(this.$refs.fileInput).trigger('click');
      }
      catch (e) {
        this.erroUpload();
      }
    },

    async handleFileChange(event) {
      try{
        this.$store.dispatch('setLoadingStatus',true);
        if(event.target.files.length === 0) {
          throw new Error('Nenhum Arquivo selecionado');
        }
        this.selectedFile = event.target.files[0];

        let validaChave = await this.uploadCnhService.validaChave();
        let buscarToken = await this.uploadCnhService.buscarToken(validaChave.res.liveness_autentication,validaChave.res.liveness_license);
        let enviaChn = await this.uploadCnhService.enviaCNH(this.selectedFile,buscarToken,validaChave.res.liveness_license,validaChave.res.liveness_autentication);

        if(enviaChn === false){
          throw new Error('Falha ao validar CNH');
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          // Use a regex to remove data url part
          const base64String = reader.result
              .replace('data:', '')
              .replace(/^.+,/, '');
          // altera para o store para nao dar erro de tamanho
          this.$store.getters.dados.cnh_digital_base = 'data:' + this.selectedFile['type'] + ';base64,' + base64String;
          this.$store.dispatch('setLoadingStatus',false);
            DispatchTags.dispatchNoninteraction('SucessoCnhDigital');
          this.$router.push({name: 'Analise'});
        };
        reader.readAsDataURL(this.selectedFile);

      }catch (e){
        console.log(e);
        this.erroUpload();
      }
    },

    erroUpload: function (){
      this.$store.dispatch('setLoadingStatus',false);
      this.selectedFile = null;
      this.$refs.fileInput.value = null;
      this.isError = true;
      this.errorMensage.title = 'Algo deu errado ao anexar sua CNH digital';
      this.errorMensage.subtitle = 'Não foi possível concluir o anexo. Você pode tentar de novo';
      this.errorMensage.button = 'Tentar de novo';
      this.errorMensage.callback = this.tentarDenovo;

      DispatchTags.dispatchScreenView('ErroUploadCnhDigital');
      DispatchTags.dispatchNoninteraction('ErroUploadCnhDigital');
    },

    tentarDenovo: function () {
      DispatchTags.dispatchInraction('ErroUploadCnhDigital');
      this.$router.push({ name: "DocSelecao" });
    }


  },
};
</script>

<style scoped>
.hidden{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/DocCnhDigital.vue